// AppHelmet.js
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

// App-wide Helmet defaults: the base browser-tab title (translatable) plus a
// template so any page that sets its own <title> renders as "Page — App Name".
const AppHelmet = () => {
  const intl = useIntl();
  const appName = intl.formatMessage({ defaultMessage: 'GreenShield Health' });

  return <Helmet defaultTitle={appName} titleTemplate={`%s — ${appName}`} />;
};

export default AppHelmet;
